












































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import { Prop } from 'vue-property-decorator'
import { BasicCouponResourceModel } from '@/modules/coupon/models/coupon-resource.model'

@Component({
  components: { BaseInput, BaseButton }
})
export default class CouponDiscountForm extends Vue {
  @Prop() coupon !: BasicCouponResourceModel
  @Prop() validateCouponUrl !: string

  discount = ''
  loading = false

  onSubmit() {
    if (this.discount && this.validateCouponUrl) {
      this.loading = true
      Inertia.post(this.validateCouponUrl, {
        'coupon-code': this.discount
      }).then(() => {
        this.loading = false
      })
    }
  }

  refreshPage() {
    window.location.reload()
  }

}
